import React from 'react'
import { connect } from 'react-redux'
import QuestionsBase from './QuestionsBase'

import { set_path } from '../actions/'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    setPath: path => dispatch( set_path(path) )
  }
}

class ConnectedQuestionResults extends React.Component {
  componentWillMount() {
    this.props.setPath('questionresults') // change depending on component
  }

  render() {
    return <QuestionsBase header="Question Results" questionbase="results" />
  }
}

const QuestionResults = connect(mapStateToProps, mapDispatchToProps)(ConnectedQuestionResults)

export default QuestionResults



// WEBPACK FOOTER //
// ./src/js/components/QuestionResults.js